import { useIsSmsCapable } from './shared/isSmsCapable';

export function useSmsAvailable(): boolean {
	return useIsSmsCapable();
}
